fx.ns("common.popups", class ProposePreview extends shared.popups.BasePersonPopup{

    constructor(model/*, noButtons*/)
    {
        super(model, fx.get("assets").personSure);

        this.contentWidth = 650;
        this.contentHeight = 225;
        this.showClose = true;
        //this.noButtons = noButtons;
    }
  

    create()
    {
        super.create();
        this.title = new fx.components.Text({text: fx.text("J'ai préparé l'aperçu de votre album"), className:"title center"});
        this.text = new fx.components.Text({text: fx.text("Cet aperçu vous montre comment sera votre album une fois imprimé.<br/>Assurez-vous de n'avoir rien oublié avant de commander."), className:"text center"});

        this.addChild(this.title);
        this.addChild(this.text);

        /*if (!this.noButtons)
        {
            this.okButton = new fx.components.Button({label : fx.text("Voir l'aperçu"), type : "filled"});
            this.cancelButton = new fx.components.Button({label : fx.text("Commander")});
            
            this.addFooterChild(this.cancelButton, {width : 250});
            this.addFooterChild(this.okButton, {width : 250});
        }
        else
        {*/
            this.okButton = new fx.components.Button({label :fx.text("Continuer"), type : "filled"});
            this.addFooterChild(this.okButton, {width : 250});
        //}
    }

    onReady()
    {
        super.onReady();

        if (this.okButton)
            this.on("click", this._onContinue, this.okButton);

        /*if (this.cancelButton)
            this.on("click", this._onOrder, this.cancelButton);*/
    }

    _onContinue()
    {
        this.close();
        //this.data.event("preview");
    }

    /*_onOrder()
    {
        this.close();
        this.data.event("order-confirmed");
    }*/


});